import { Foot, FootItems, FootItem, FootHeader, FootBody } from "../styled/Footer";

function Footer({color}) {
  return (
    <Foot>
      <FootItems >
        <FootItem col="1" color={color}>
          <FootHeader>contact</FootHeader>
          <FootBody>
          <a href="mailto:info@voidchicago.com">info@voidchicago.com</a>
          </FootBody>
          <FootHeader>media</FootHeader>
          <FootBody>
          <a href="mailto:media@voidchicago.com">media@voidchicago.com</a>
          </FootBody>
          </FootItem>
        <FootItem col="2" color={color}>
          <FootHeader>now taking reservations</FootHeader>
          <FootBody>
          <a href="https://resy.com/cities/chicago-il/venues/void">reserve a table</a>
          </FootBody>
          <FootHeader>event inquiries</FootHeader>
          <FootBody>
          <a href="mailto:events@voidchicago.com">events@voidchicago.com</a>
          </FootBody>
        </FootItem>
        <FootItem col="3" color={color}>
          <FootHeader>hours</FootHeader>
          <FootBody>
          <p>Tuesday - Saturday</p>
          <p>Dinner: 5:00 - 10:00</p>
          <p>Sunday</p>
          <p>Dinner: 4:00 - 9:00</p>
          <p>Closed Monday</p>
          </FootBody>
        </FootItem>
        <FootItem col="4" end color={color}>
          <FootHeader>address</FootHeader>
          <FootBody>
          <a href="https://www.google.com/maps/dir//2937+N+Milwaukee+Ave+Chicago+IL+60618" target="_blank">2937 N Milwaukee Ave.
          </a>
          <a href="https://www.google.com/maps/dir//2937+N+Milwaukee+Ave+Chicago+IL+60618">Chicago, IL</a>
          </FootBody>


          {/* /////////////// */}
                {/* map? */}
          {/* /////////////// */}

        </FootItem>
      </FootItems>
    </Foot>
  );
}

export default Footer;
